'use client';

import { Content } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import React, { useState } from 'react';

const HUBSPOT_PORTAL_ID = `${process.env.NEXT_PUBLIC_HS_PLATFORM_ID}`;

export const InlineFormVariation = ({
  slice,
}: {
  slice: Content.ImageWithFormSliceInlineForm;
}) => {
  const { title } = slice.primary;

  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const HUBSPOT_FORM_ID = slice.primary.hubspot_form_id;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const url = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${HUBSPOT_FORM_ID}`;

      const payload = {
        fields: [{ name: 'email', value: email }],
        context: {
          pageUri: window.location.href,
          pageName: document.title,
        },
      };

      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error('HubSpot form submission failed');
      }

      setSubmitted(true);
    } catch {
      setError('There was a problem submitting the form. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      data-slice-type="inlineForm"
      data-slice-variation={slice.variation}
      className="py-8 bg-black text-white"
    >
      <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row items-center gap-4 px-4">
        <div className="flex-1 text-center lg:text-left">
          <PrismicRichText field={title} />
        </div>

        {!submitted ? (
          <form onSubmit={handleSubmit} className="flex w-full max-w-lg">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 border border-white rounded-l-full bg-transparent px-4 py-2 text-white focus:outline-none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 rounded-r-full bg-[#4B4B4B] hover:bg-[#5c5c5c] transition disabled:opacity-50"
            >
              {loading ? 'Sending...' : 'Send'}
            </button>
          </form>
        ) : (
          <div className="text-green-400 font-semibold">
            Thank you! You’ll receive an email shortly with the PDF case study.
          </div>
        )}

        {error && <div className="text-red-400 mt-2">{error}</div>}
      </div>
    </section>
  );
};
